// Mirrors `MilestoneDependency.DependencyType` on the backend
// (apps/core/models.py) — the numeric values are the wire format.
enum MilestoneDependencyType {
  FINISH_TO_START = 1,
  START_TO_START = 2,
  FINISH_TO_FINISH = 3,
  START_TO_FINISH = 4
}

interface MilestoneDependency {
  id: string
  source_milestone: string
  // Absent from a server that predates them; null for an unnamed milestone.
  source_milestone_name?: string | null
  target_milestone: string
  target_milestone_name?: string | null
  type: MilestoneDependencyType
  type_display: string
  lag_days: number
  created: string
  updated: string
}

export { MilestoneDependencyType }
export type { MilestoneDependency }
